<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import flashMessage from "../../components/flashMessahe";
import moment from "moment";
import Multiselect from 'vue-multiselect';
import VueSweetalert2 from "vue-sweetalert2";
import { ModelSelect } from 'vue-search-select';
import ErrorMessage from "../../components/error-message";

import {
  required,
  email,
  minLength,
  sameAs,
  maxLength,
  minValue,
  maxValue,
  numeric,
  url,
  alphaNum,
} from "vuelidate/lib/validators";

export default {
  components: {
      ErrorMessage,
    Layout,
    PageHeader,
    flashMessage,
    Multiselect,
      ModelSelect,
  },
  data() {
    return {
      errorMessage: "",
      disable:true,
      continuous_rule:false,
      title: "Hotel Markup Commission update",
      agents: [],
      admins: [],
      airlines: [],
      vendors: [],
      roles: [],
      uuid: "",
      item: {},
      rolelist: [],
      exclude_class: [],
      options: [
        { name: 'A' },
        { name: 'B' },
        { name: 'C' },
        { name: 'D' },
        { name: 'E' },
        { name: 'F' },
        { name: 'G' },
        { name: 'H' },
        { name: 'I' },
        { name: 'J' },
      ],
      items: [
        {
          text: "Hotel Markup Commission",
          href: "/",
        },
        {
          text: "Update",
          active: true,
        },
      ],
      status: "not_accepted",
      checkCustom: "not_accepted",
      checked: false,
      errors: null,
        visible:false,
        message:"",
        lineError:true,
      form: {
          start_dateTime: "",
          end_dateTime:"",
          destination: "",
          country_code: "",
          api_id: "",
          check_in_date:"",
          check_out_date:"",
          user_group_id: "",
          account_type:"",
          user_id: "",
          hotel_name: "",
          markup_type: "",
          markup_value: "",
          commission_type: "",
          commission_value: "",
          exclude_destination:"",
      },
      submitform: false,
      submitted: false,
    };
  },
    validations: {
        form: {
            start_dateTime: {
                required,
            },
        },
    },
    watch: {
        continuous_rule: function (value) {
            if(value){
                this.form.end_dateTime="";
            }
        }
    },
  created() {
    this.uuid = this.$route.params.uuid;
  },
  mounted() {
    // this.getAgentList();
    // this.getAirlineList();
    this.getVendorList();
    this.getRoleList();
    this.getAdminList();
    this.mcDetails();
  },
  methods: {
      onClose(){
          this.visible=false;
      },
    format(value, event) {
      return moment(value).format("YYYY-MM-DD hh:mm:ss");
    },
      async getAdminList() {
          try {
              axios
                  .get("/api/user/approved/list", {
                      params: {
                          accessToken: localStorage.getItem("access_tocken"),
                      },
                  })
                  .then((response) => {
                      if (response.data.status) {
                          let temp=response.data.data;
                          let i;
                          let arr=[];
                          let nullArr=[];
                          nullArr.value=null;
                          nullArr.text='all';
                          arr.push(nullArr);
                          for (i=0;i<temp.length;i++){
                              if(temp[i].account_type=='b2b' && temp[i].approved_agents[0]!=undefined){
                                  if(temp[i].approved_agents[0].approval_status=='approved') {
                                      temp[i].value = temp[i].id;
                                      temp[i].text = temp[i].first_name + ' ' + temp[i].last_name + ' (' + temp[i].username + ')';
                                      arr.push(temp[i]);
                                  }
                              }
                              if(temp[i].account_type=='b2c' && temp[i].first_name != null){
                                  temp[i].value = temp[i].id;
                                  temp[i].text = temp[i].first_name + ' ' + temp[i].last_name + ' (' + temp[i].username + ')';
                                  arr.push(temp[i]);
                              }

                          }
                          this.admins = arr;
                      } else {
                          var str = response.data.message;
                          var jsonParse = JSON.parse(str);
                          this.errorCheck(jsonParse);
                      }
                  })
                  .catch((error) => {
                      console.log(error.message);
                  });
          } catch (err) {
              console.log(err);
          }
      },
    async mcDetails() {
      try {
        axios
          .post("/api/hotel_markup_com/detail/" + this.uuid, {
            accessToken: localStorage.getItem("access_tocken"),
          })
          .then((response) => {
            if (response.data.status) {
              var data = response.data.data;
                if(data.end_dateTime==null){
                    this.continuous_rule=true;
                }
              this.form.start_dateTime = data.start_dateTime;
              this.form.end_dateTime=data.end_dateTime,
                  this.form.destination=data.destination,
                  this.form.country_code=data.country_code,
                  this.form.api_id=data.api_id,
                  this.form.check_in_date=data.check_in_date,
                  this.form.check_out_date=data.check_out_date,
                  this.form.user_group_id=data.user_group_id,
                  this.form.account_type=data.account_type,
                  this.form.user_id=data.user_id,
                  this.form.hotel_name=data.hotel_name,
                  this.form.markup_type=data.markup_type,
                  this.form.markup_value=data.markup_value,
                  this.form.commission_type=data.commission_type,
                  this.form.commission_value=data.commission_value,
                  this.form.exclude_destination=data.exclude_destination
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
    async getVendorList() {
      try {
        axios
          .get("/api/vendor/list", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
            },
          })
          .then((response) => {
            if (response.data.status) {
              this.vendors = response.data.data;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
    // async getAirlineList() {
    //   try {
    //     axios
    //       .get("/api/airline/list", {
    //         params: {
    //           accessToken: localStorage.getItem("access_tocken"),
    //         },
    //       })
    //       .then((response) => {
    //         if (response.data.status) {
    //             var temp=response.data.data;
    //             var i;
    //             for (i=0;i<temp.length;i++){
    //                 temp[i].value=temp[i].code;
    //                 temp[i].text=temp[i].name+' ('+temp[i].code+')';
    //             }
    //             this.airlines = temp;
    //         } else {
    //           var str = response.data.message;
    //           var jsonParse = JSON.parse(str);
    //           this.errorCheck(jsonParse);
    //         }
    //       })
    //       .catch((error) => {
    //         console.log(error.message);
    //       });
    //   } catch (err) {
    //     console.log(err);
    //   }
    // },
    async getAgentList() {
      try {
        axios
          .get("/api/agent/list", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
            },
          })
          .then((response) => {
            if (response.data.status) {
              this.agents = response.data.data;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
    async getRoleList() {
      try {
        axios
          .get("/api/role_list", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
            },
          })
          .then((response) => {
            if (response.data.status) {
              this.roles = response.data.data;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
    formSubmit(event) {
      if(this.form.api_id=='null'){
        this.form.api_id=null;
      }
       if(this.form.user_role_id=='null'){
        this.form.user_role_id=null;
      }
        if(this.form.user_id=='null'){
        this.form.user_id=null;
      }
        if(this.form.account_type=='null'){
            this.form.account_type=null;
        }
       if(this.form.markup_type=='null'){
        this.form.markup_type=null;
      }
      if(this.form.commission_type=='null'){
        this.form.commission_type=null;
      }
      if(this.form.country_code=='null'){
        this.form.country_code=null;
      }
      if(this.form.agent_type='null'){
        this.form.agent_type=null;
      }
      if(this.form.journey_type=='null'){
        this.form.journey_type=null;
      }
        if(this.form.end_dateTime!=""){
            this.form.end_dateTime=moment(new Date(this.form.end_dateTime)).format(
                "YYYY-MM-DD HH:mm:ss"
            )
        }

      this.submitted = true;
      this.$v.$touch();
      axios
        .put("/api/hotel_markup_com/update", {
          uuid: this.uuid,
          start_dateTime: moment(new Date(this.form.start_dateTime)).format(
            "YYYY-MM-DD HH:mm:ss"
          ),
            end_dateTime:this.form.end_dateTime,
            destination: this.form.destination,
            country_code: this.form.country_code,
            api_id: this.form.api_id,
            check_in_date: this.form.check_in_date,
            check_out_date: this.form.check_out_date,
            user_group_id: this.form.user_group_id,
            account_type: this.form.account_type,
            user_id: this.form.user_id,
            hotel_name: this.form.hotel_name,
            markup_type: this.form.markup_type,
            markup_value: this.form.markup_value,
            commission_type: this.form.commission_type,
            commission_value: this.form.commission_value,
            exclude_destination:this.form.exclude_destination,
          accessToken: localStorage.getItem("access_tocken"),
        })
        .then((response) => {
          if (response.data.status) {
            this.$refs.hotelmarkupcomupdate.reset();
            this.$swal("Good job!", "Hotel Markup Commission Updated", "success");
            this.$router.push({ name: "hotel_markup_commission_list" });
          } else {
            var str = response.data.message;
            var jsonParse = JSON.parse(str);
            this.errorCheck(jsonParse);
          }
        })
        .catch((error) => {
          if (error.response != undefined) {
            this.errors = error.response.data.errors;
          }
        });
    },
    errorCheck(obj) {
        if(obj.statusCode == 403){
            this.visible=true;
            this.lineError=false;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
        this.errors = obj.message;
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (
        obj.message !== "Token has expired" &&
        obj.message !== "The given data was invalid."
      ) {
        this.errors = obj.message;
      } else if (obj.message == "The given data was invalid.") {
        this.errors = obj.errors;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data save",
        });
      }
    },
    getRoleListOnChange(event) {
      var _that = this;
      try {
        axios
          .get("/api/role/type", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
              type: event.target.value,
            },
          })
          .then((response) => {
            if (response.data.status) {
              _that.roles = response.data.data;
              _that.rolelist = [];
              response.data.data.map(function(value, key) {
                _that.rolelist[value.id] = value.type;
              });
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              _that.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
    getUserOnChange(event) {
      var _that = this;
      try {
        axios
          .get("/api/user/type", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
              type: this.rolelist[event.target.value],
            },
          })
          .then((response) => {
            if (response.data.status) {
                let temp=response.data.data;
                let i;
                let arr=[];
                let nullArr=[];
                nullArr.value=null;
                nullArr.text='all';
                arr.push(nullArr);
                for (i=0;i<temp.length;i++){
                    if(temp[i].account_type=='b2b' && temp[i].approved_agents[0]!=undefined){
                        if(temp[i].approved_agents[0].approval_status=='approved') {
                            temp[i].value = temp[i].id;
                            temp[i].text = temp[i].first_name + ' ' + temp[i].last_name + ' (' + temp[i].username + ')';
                            arr.push(temp[i]);
                        }
                    }
                    if(temp[i].account_type=='b2c' && temp[i].first_name != null){
                        temp[i].value = temp[i].id;
                        temp[i].text = temp[i].first_name + ' ' + temp[i].last_name + ' (' + temp[i].username + ')';
                        arr.push(temp[i]);
                    }

                }
                _that.admins = arr;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              _that.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
    resetForm(event) {
      event.target.reset();
    },
    //  applyAdvancedRules(event){
    //   if(event.target.checked==true){
    //     this.checked=true;
    //     this.disable=false;
    //     this.form.apply_advanced_rules="1";
    //   }
    //   else{
    //     this.disable=true;
    //     this.checked=false;
    //     this.form.apply_advanced_rules="0";
    //   }
    // },
  },
};
</script>


<template>
    <Layout>
        <flashMessage/>
        <PageHeader :title="title" :items="items" />
        <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
        <div class="row">
            <div class="col-lg-12 col-sm-12">
                <div class="card">
                    <div class="card-body">
                        <div v-if="errors" class="font-bold mb-4 ">
                            <div v-for="(v, k) in errors" :key="k">
                                <p v-for="error in v" :key="error" class="text-sm">
                                    {{ error }}
                                </p>
                            </div>
                        </div>
                        <b-form class="needs-validation" ref="hotelmarkupcomupdate" @submit.prevent="formSubmit">
                            <div class="card">
                                <div class="card-body">
                                    <h4 class="card-title mb-4 alert alert-success"><i class="bx bx-time-five"></i> Rules Time Set</h4>
                                    <!--                  <p class="badge badge-info">Continuous Rule</p>-->
                                    <!--                  <input type="checkbox" v-model="continuous_rule" @change="applyContinuousRule($event)" />-->
                                    <div class="row">
                                        <div class="col-md-6">
                                            <b-form-group
                                                id="lb_start_dateTime"
                                                label-cols-sm="12"
                                                label-cols-lg="12"
                                                label="Start Date"
                                                label-for="start_dateTime"
                                            >
                                                <b-form-datepicker id="start_dateTime" v-model="form.start_dateTime" class="mb-2"></b-form-datepicker>
                                                <div
                                                    v-if="submitted && $v.form.start_dateTime.$error"
                                                    class="invalid-feedback"
                                                >
                                                    <span v-if="!$v.form.start_dateTime.required">This value is required.</span>
                                                </div>
                                                                          <div>
                                                                              <b-form-checkbox
                                                                                  id="checkbox-1"
                                                                                  v-model="continuous_rule"
                                                                                  name="checkbox-1"
                                                                                  switch
                                                                              >
                                                                                  Apply Continuous Rule
                                                                              </b-form-checkbox>
                                                                          </div>
                                            </b-form-group>

                                        </div>
                                        <div class="col-md-6">
                                            <b-form-group
                                                id="lb_end_dateTime"
                                                label-cols-sm="12"
                                                label-cols-lg="12"
                                                label="End Date"
                                                label-for="end_dateTime"
                                            >
                                                <b-form-datepicker id="end_dateTime" v-model="form.end_dateTime" :disabled="this.continuous_rule" class="mb-2"></b-form-datepicker>
                                                <!--  <div
                                                 v-if="submitted && $v.form.end_dateTime.$error"
                                                 class="invalid-feedback"
                                                 >
                                                 <span v-if="!$v.form.end_dateTime.required">This value is required.</span>
                                                 </div> -->
                                            </b-form-group>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="destination">Destination</label>
                                                <input
                                                    id="destination"
                                                    v-model="form.destination"
                                                    name="destination"
                                                    type="text"
                                                    class="form-control"
                                                    placeholder="Type Destination "
                                                />
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="country_code">Country Code</label>
                                                <input
                                                    id="country_code"
                                                    v-model="form.country_code"
                                                    name="country_code"
                                                    type="text"
                                                    class="form-control"
                                                    placeholder="Type Country Code"
                                                />
<!--                                                <div-->
<!--                                                    v-if="submitted && $v.form.country_code.$error"-->
<!--                                                    class="invalid-feedback"-->
<!--                                                >-->
<!--                                                    <span v-if="!$v.form.country_code.required">This value is required.</span>-->
<!--                                                </div>-->
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="hotel_name">Hotel Name</label>
                                                <input
                                                    id="hotel_name"
                                                    v-model="form.hotel_name"
                                                    name="hotel_name"
                                                    type="text"
                                                    class="form-control"
                                                    placeholder="Type Hotel Name"
                                                />
<!--                                                <div-->
<!--                                                    v-if="submitted && $v.form.hotel_name.$error"-->
<!--                                                    class="invalid-feedback"-->
<!--                                                >-->
<!--                                                    <span v-if="!$v.form.hotel_name.required">This value is required.</span>-->
<!--                                                </div>-->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-body">
                                    <h4 class="card-title mb-4 alert alert-success"><i class="bx bx-user-plus"></i> Set API User</h4>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <b-form-group
                                                id="lb1_end_dateTime"
                                                label-cols-sm="12"
                                                label-cols-lg="12"
                                                label="Check In Date"
                                                label-for="check_in_date"
                                            >
                                                <b-form-datepicker id="check_in_date" v-model="form.check_in_date" class="mb-2"></b-form-datepicker>
                                                <!--  <div
                                                 v-if="submitted && $v.form.end_dateTime.$error"
                                                 class="invalid-feedback"
                                                 >
                                                 <span v-if="!$v.form.end_dateTime.required">This value is required.</span>
                                                 </div> -->
                                            </b-form-group>
                                        </div>
                                        <div class="col-md-6">
                                            <b-form-group
                                                id="lb12_end_dateTime"
                                                label-cols-sm="12"
                                                label-cols-lg="12"
                                                label="Check Out Date"
                                                label-for="check_out_date"
                                            >
                                                <b-form-datepicker id="check_out_date" v-model="form.check_out_date" class="mb-2"></b-form-datepicker>
                                                <!--  <div
                                                 v-if="submitted && $v.form.end_dateTime.$error"
                                                 class="invalid-feedback"
                                                 >
                                                 <span v-if="!$v.form.end_dateTime.required">This value is required.</span>
                                                 </div> -->
                                            </b-form-group>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="api_id">API ID</label>
                                                <select
                                                    id="api_id"
                                                    name="api_id"
                                                    v-model="form.api_id"
                                                    class="form-control"
                                                  >
                                                    <option value="" disabled style="display:none" selected>Select Api Id</option>
                                                    <option value="null">All</option>
                                                    <option v-for="(vendor, index) in vendors" :value="vendor.id" v-if="vendor.is_active==1"
                                                            v-bind:key="index">{{ vendor.api_provider }}
                                                    </option>
                                                </select>
                                                <!--    <div
                                                     v-if="submitted && $v.form.api_id.$error"
                                                     class="invalid-feedback"
                                                   >
                                                     <span v-if="!$v.form.api_id.required">This value is required.</span>
                                                   </div> -->
                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="agent_type">User Type</label>
                                                <select
                                                    id="agent_type"
                                                    name="agent_type"
                                                    v-model="form.account_type"
                                                    v-on:change="getRoleListOnChange"
                                                    class="form-control"
                                                    placeholder="Type User type"
                                                   >
                                                    <option value="" disabled style="display:none" selected>Select User Type</option>
                                                    <option value="null">All</option>
                                                    <option value="b2b">B2B</option>
                                                    <option value="b2c">B2C</option>
                                                </select>
                                                <!--     <div
                                                      v-if="submitted && $v.form.agent_type.$error"
                                                      class="invalid-feedback"
                                                    >
                                                      <span v-if="!$v.form.agent_type.required">This value is required.</span>
                                                    </div> -->
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="user_role_id">Select Role</label>
                                                <select
                                                    id="user_role_id"
                                                    name="user_role_id"
                                                    v-model="form.user_group_id"
                                                    class="form-control"
                                                    v-on:change="getUserOnChange"
                                                    >
                                                    <option value="" disabled style="display:none" selected>Select Role</option>
                                                    <option value="null">All</option>
                                                    <option v-for="(role, index) in roles" v-if="role.type!='admin'" v-bind:key="index" :value="role.id">{{ role.name}}
                                                    </option>
                                                </select>
                                                <!--  <div
                                                   v-if="submitted && $v.form.user_role_id.$error"
                                                   class="invalid-feedback"
                                                 >
                                                   <span v-if="!$v.form.user_role_id.required">This value is required.</span>
                                                 </div> -->
                                            </div>
                                        </div>
<!--                                        <div class="col-md-6">-->
<!--                                            <div class="form-group">-->
<!--                                                <label for="user_id">Select User</label>-->
<!--                                                <select-->
<!--                                                    id="user_id"-->
<!--                                                    name="user_id"-->
<!--                                                    v-model="form.user_id"-->
<!--                                                    class="form-control"-->
<!--                                                    placeholder="Type Select User"-->
<!--                                                    >-->
<!--                                                    <option value="" disabled style="display:none" selected>Select User</option>-->
<!--                                                    <option value="null">All</option>-->
<!--                                                    <option v-for="(admin, index) in admins" v-if="admin.account_type != 'admin'" :value="admin.id"-->
<!--                                                            v-bind:key="index">{{ admin.first_name+' '+admin.last_name }}-->
<!--                                                    </option>-->
<!--                                                </select>-->
<!--                                                &lt;!&ndash;    <div-->
<!--                                                     v-if="submitted && $v.form.user_id.$error"-->
<!--                                                     class="invalid-feedback"-->
<!--                                                   >-->
<!--                                                     <span v-if="!$v.form.user_id.required">This value is required.</span>-->
<!--                                                   </div> &ndash;&gt;-->
<!--                                            </div>-->
<!--                                        </div>-->
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>Select User</label>
                                                <model-select :options="admins"
                                                              v-model="form.user_id"
                                                              placeholder="Select User">
                                                </model-select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-body">
                                    <h4 class="card-title mb-4 alert alert-success"><i class="bx bx-shield"></i> Set Markup Commission</h4>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="markup_type">Markup Type</label>
                                                <select
                                                    id="markup_type"
                                                    name="markup_type"
                                                    v-model="form.markup_type"
                                                    class="form-control"
                                                    placeholder="Type markup type"
                                                 >
                                                    <option value="" disabled style="display:none" selected>Select Markup Type</option>
                                                    <option value="flat">flat</option>
                                                    <option value="%">Percentage</option>
                                                </select>
                                                <!--  <div
                                                   v-if="submitted && $v.form.markup_type.$error"
                                                   class="invalid-feedback"
                                                 >
                                                   <span v-if="!$v.form.markup_type.required">This value is required.</span>
                                                 </div> -->
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="commission_type">Commission Type</label>
                                                <select
                                                    id="commission_type"
                                                    name="commission_type"
                                                    v-model="form.commission_type"
                                                    class="form-control"
                                                    placeholder="Type Commission type"
                                                    >
                                                    <option value="" disabled style="display:none" selected>Select Commission Type</option>
                                                    <option value="flat">flat</option>
                                                    <option value="%">Percentage</option>
                                                </select>
                                                <!--     <div
                                                      v-if="submitted && $v.form.commission_type.$error"
                                                      class="invalid-feedback"
                                                    >
                                                      <span v-if="!$v.form.commission_type.required">This value is required.</span>
                                                    </div> -->
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="markup_value">Markup Value</label>
                                                <input
                                                    id="markup_value"
                                                    v-model="form.markup_value"
                                                    name="markup_value"
                                                    type="number"
                                                    class="form-control"
                                                    placeholder="Type Markup Value"

                                                />
<!--                                                <div-->
<!--                                                    v-if="submitted && $v.form.markup_value.$error"-->
<!--                                                    class="invalid-feedback"-->
<!--                                                >-->
<!--                                                    <span v-if="!$v.form.markup_value.required">This value is required.</span>-->
<!--                                                </div>-->
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="commission_value">Commission Value</label>
                                                <input
                                                    id="commission_value"
                                                    v-model="form.commission_value"
                                                    name="commission_value"
                                                    type="number"
                                                    class="form-control"
                                                    placeholder="Type Commission Value"

                                                />
<!--                                                <div-->
<!--                                                    v-if="submitted && $v.form.commission_value.$error"-->
<!--                                                    class="invalid-feedback"-->
<!--                                                >-->
<!--                                                    <span v-if="!$v.form.commission_value.required">This value is required.</span>-->
<!--                                                </div>-->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!--              <h2 class="badge badge-danger">Apply Advance Rule</h2> <input type="checkbox" v-model="checked" @change="applyAdvancedRules($event)" />-->
                            <div class="card border border-danger">
                                <div class="card-body">
                                    <h4 class="card-title mb-4 alert alert-success"><i class="bx bx-hash"></i> Add Restriction Of Rule</h4>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="exclude_destination">Exclude Destination</label>
                                                <input
                                                    id="exclude_destination"
                                                    v-model="form.exclude_destination"
                                                    name="exclude_destination"
                                                    type="text"
                                                    class="form-control"
                                                    placeholder="Type Exclude Destination"

                                                />
<!--                                                <div-->
<!--                                                    v-if="submitted && $v.form.exclude_destination.$error"-->
<!--                                                    class="invalid-feedback"-->
<!--                                                >-->
<!--                                                    <span v-if="!$v.form.exclude_destination.required">This value is required.</span>-->
<!--                                                </div>-->
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <button class="btn btn-primary" type="submit">Submit</button>
                        </b-form>
                    </div>
                </div>
                <!-- end card -->
            </div>
            <!-- end col -->
        </div>
        <!-- end row -->
    </Layout>
</template>
